/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/reducers/app.reducer.js
 * File: app.reducer.js
 * Created Date: Sunday, January 27th 2019, 7:10:00 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 11 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import * as Actions from '../actions'
import { combineReducers } from 'redux'

const initialUserState = {}
const initialSharedState = {
  title: ''
}

const reducer = combineReducers({
  user: appUserReducer,
  shared: sharedDataReducer
})
export default reducer

function appUserReducer (state = initialUserState, action) {
  switch (action.type) {
    case Actions.GET_APP_DATA: return requestAppResolve(state, action)
    case Actions.GET_APP_DATA_SUCCESS: return reduceUserResolve(state, action)
    case Actions.GET_APP_DATA_FAILURE: return reduceUserReject(state, action)
    default: return state
  }
}

function sharedDataReducer (state = initialSharedState, action) {
  switch (action.type) {
    case Actions.SET_FUSE_TOOLBAR_TITLE: return setToolbarTitle(state, action)
    case Actions.GET_APP_DATA_SUCCESS: return reduceAppDataResolve(state, action)
    default: return state
  }
}

function requestAppResolve (state, action) {
  return {
    ...state
  }
}

function reduceAppDataResolve (state, action = {}) {
  return Object.assign({}, state, {
    app: action.data.app
  })
}

function reduceUserResolve (state, action = {}) {
  return Object.assign({}, state, action.data.user.user)
}

function reduceUserReject (state, action = {}) {
  return Object.assign({}, state, {
    error: {
      message: action.error.message,
      stack: action.error.stack
    }
  })
}

function setToolbarTitle (state, action = {}) {
  return Object.assign({}, state, { title: action.title || '' })
}
